
import React, { Component } from 'react'; 
import _ from 'lodash';
import { connect } from 'react-redux';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {AuditTypeList} from '../DynamicForm/FormAction';
import {SubmitComplianceForm, SearchInformation, SearchTepmlateInformation, ScoreCalculation, ResetUserData, closeModalPopUp, resetTemplate, ComplianceSearchCompleted} from './complinaceaction'
import ComplianceForm from './complainceForm';
import SearchComplianceRecord from './SearchComplianceRecord';
import {Tabs, Tab} from 'react-bootstrap';
import ShowModalPopUp from '../ShowModalPopUp';
class ComplianceIndex extends Component {
  constructor(props){
		super(props)
		this.state={
      
		}
	}
  componentDidMount(){   
    this.props.TokenValidation()    
    this.props.actioninventoryUserMapped()  
    this.props.auditTypeList()
  }
  loadTabContent = (prop) => {
    this.setState({key:prop})
	}
	ScreensComp = () =>{        
    const{complianceuserData, compliancetemplate, inventoryMapped, ScoreCalculation, auditTypes, loginAction, searchData} = this.props;    
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "COMPLIANCE"})
    let defaultKey = moduleAccess.screens[0].screenUId
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "HOME_COMPLIANCE"){ 
          returnObj.push(<Tab eventKey="HOME_COMPLIANCE" title="AUDIT" key={1}>	
					<ComplianceForm inventory={inventoryMapped} 
              complianceuserData={complianceuserData} compliancetemplate={compliancetemplate}
              auditTypes={auditTypes} loginUserName={loginAction.userName}
              function={this.props}/>
				</Tab>)}
        if(obj.screenUId === "SEARCH_COMPLIANCE"){ 
          returnObj.push(<Tab eventKey="SEARCH_COMPLIANCE" title="SEARCH" key={2}>	
					 <SearchComplianceRecord action={this.props}  searchData ={searchData} ScoreCalculation={ScoreCalculation}
						inventory={inventoryMapped} auditTypes={auditTypes}
					/>		
        </Tab>)}
    })    
    
    returnObj =	_.sortBy(returnObj, ['key'])  
    return (<Tabs defaultActiveKey={defaultKey} transition={false}
      activeKey={(key) ? key : defaultKey}
      unmountOnExit={true}
      id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
      {returnObj}</Tabs>)
    }     
  }
  
 
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
		}	
    return(
      <div className={(style) ? 'user' : "userSmall"}>
      {this.ScreensComp()}
      {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        
      </div>
      )
  }
}    
function mapStateToProps(state){
  return{
   inventoryMapped: state.UserReducer.inventoryMapped,
   complianceuserData: state.ComplianceReducer.complianceuserData,
   compliancetemplate: state.ComplianceReducer.compliancetemplate,
   size: state.UserReducer.large,   
   searchData: state.ComplianceReducer.searchData,
   auditTypes: state.FormReducer.auditTypes,
   showerror:  state.ComplianceReducer.showerror, 
   errmessage:  state.ComplianceReducer.errmessage,
   loginAction: state.LoginReducer.loginAction,
   showModalLogin: state.UserReducer.showModalLogin,
   ScoreCalculation: state.ComplianceReducer.ScoreCalculation
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),  
  auditTypeList:  () =>dispatch(AuditTypeList()),
  actionSearchCompleted:  (q) =>dispatch(ComplianceSearchCompleted(q)),
  actionSubmit:  (a) =>dispatch(SubmitComplianceForm(a)),
  actionSearch:  (a) =>dispatch(SearchInformation(a)),
  actionSearchTemplate:  (a) =>dispatch(SearchTepmlateInformation(a)),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  TokenValidation : (a) => dispatch(TokenValidation(a)) ,
  resetTemplate: (a) => dispatch(resetTemplate()),
  ResetUserData: () => dispatch(ResetUserData()),
  complianceScoreCalculation: (a) => dispatch(ScoreCalculation(a)),  
})

export default connect(mapStateToProps, mapDispatchToProps)(ComplianceIndex);


